import { IUser } from 'findem-types';
import React from 'react';

const UserContext = React.createContext({ user: {} as IUser, setUser: (user: IUser) => {} });
export const Consumer = UserContext.Consumer;

export default UserContext;